import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupService = () => {
  //page hook
  const { t } = useTranslation();

  return {
    serviceName: Yup.string().required(
      t("validation.required", {
        serviceName: t("page.serviceName"),
      })
    )
  };
};
